
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/promotion/[permalink]",
      function () {
        return require("private-next-pages/discover/promotion/[permalink].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/promotion/[permalink]"])
      });
    }
  